/* eslint-disable import/extensions */
import { Notification } from "element-ui";
import { hGetPathinfo, hConvertImageToBase64 } from "@/utils/helpers";
import ShUserAvatar from "@/components/Helpers/ShUserAvatar";

// @vue/component
export default {
  name: "ShUserAvatarUpload",

  components: { ShUserAvatar },

  props: {
    avatar: {
      type: String,
      default: "/static/img/default-avatar.png"
    },
    width: {
      type: String,
      default: "24px"
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      userAvatar: null
    };
  },

  created() {
    this.userAvatar = this.avatar;
  },

  watch: {
    avatar(newValue) {
      this.userAvatar = newValue;
    }
  },

  methods: {
    __validateFileExtenstion(file) {
      const allowedFileExtensions = ["png", "jpg", "jpeg", "bmp", "gif"];
      const fileExtension = hGetPathinfo(file.name, "PATHINFO_EXTENSION").extension;

      if (
        !allowedFileExtensions.includes(fileExtension) ||
        !allowedFileExtensions.includes(file.type.split("/")[1])
      ) {
        Notification.error({
          title: "Error",
          message: `Nieprawidłowe rozszerzenie pliku. Dozwolone pliku to: ${allowedFileExtensions.join(
            "/"
          )}`
        });
        return false;
      }

      return true;
    },
    __validateFileSize(file) {
      const maxSize = 200000;
      if (maxSize < file.size) {
        Notification.error({
          title: "Error",
          message: "Plik jest za duży. Maksymalny rozmiar pliku to: 200KB"
        });
        return false;
      }
      return true;
    },
    async handleUploadFile(fileInfo) {
      console.log(fileInfo);
      const { file } = fileInfo;
      if (!this.__validateFileExtenstion(file)) {
        return false;
      }
      if (!this.__validateFileSize(file)) {
        return false;
      }

      const url = await this.$store.dispatch("user/uploadAvatar", {
        avatar: file
      });

      // Update local avatar immediately
      this.userAvatar = url;
      
      // Emit the URL to parent component
      this.$emit("uploadFile", url);

      return true;
    }
  }
};
